/**
 * Hinweis hinter dem Label Mehrwertsteuer.
 *
 * Auf dem Desktop reicht Hover, das macht das CSS. Auf Touchgeraeten gibt es
 * keinen Hover, deshalb schaltet ein Tippen den Hinweis auf. Der Hinweis
 * bleibt offen, solange der Zeiger darin liegt oder etwas darin den Fokus
 * hat, sonst waere der Link zum Ratgeber nicht erreichbar.
 */
(function () {
  if (window.__steuersatzTipBereit) {
    return;
  }
  window.__steuersatzTipBereit = true;

  const OFFEN = 'ist-offen';

  function schliesseAlle(ausser) {
    document.querySelectorAll('[data-steuersatz-tip].' + OFFEN).forEach(function (tip) {
      if (tip === ausser) {
        return;
      }
      tip.classList.remove(OFFEN);
      const knopf = tip.querySelector('.steuersatz-tip__knopf');
      if (knopf) {
        knopf.setAttribute('aria-expanded', 'false');
      }
    });
  }

  document.addEventListener('click', function (event) {
    const knopf = event.target.closest ? event.target.closest('.steuersatz-tip__knopf') : null;

    if (knopf) {
      event.preventDefault();
      const tip = knopf.closest('[data-steuersatz-tip]');
      const wirdGeoeffnet = !tip.classList.contains(OFFEN);
      schliesseAlle(tip);
      tip.classList.toggle(OFFEN, wirdGeoeffnet);
      knopf.setAttribute('aria-expanded', wirdGeoeffnet ? 'true' : 'false');
      return;
    }

    // Ein Klick im Hinweis selbst schliesst nicht, sonst ginge der Link verloren
    if (event.target.closest && event.target.closest('.steuersatz-tip__inhalt')) {
      return;
    }
    schliesseAlle(null);
  });

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape') {
      schliesseAlle(null);
    }
  });
})();
